import script from "./MoreOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreOptions.vue?vue&type=script&setup=true&lang=js"

import "./MoreOptions.vue?vue&type=style&index=0&id=794b21a4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\diogo.correia\\Documents\\INM\\BAI\\hybrid-banking-v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794b21a4"]])

export default __exports__